const common = {
    'common.sure': 'OK',
    'common.save': 'Save',
    'common.cancel': 'Cancel',
    'common.loading': 'loading...',
    'common.loading.noMore': 'no more~',
    'common.loading.loading1': 'loading',
    'common.success': 'success',
    'common.fail': 'fail',
    'common.unKnowError': 'Unknown exception',
    'common.unitDayOdd': 'day',
    'common.unitDayPlural': 'days',
    'common.unitMonthOdd': 'month',
    'common.unitMonthPlural': 'months',
    'common.infiniteAct': '1st unlimited !',
    'common.label': 'Promotion Coming',
    'common.404': 'Oops. The page you requested was not found!'
}
const language = {
    'lang.chinese': 'Chinese',
    'lang.english': 'English',
    'lang.germany': 'German',
    'lang.spanish': 'Spanish',
    'lang.french': 'French',
    'lang.italian': 'Italian',
    'lang.portuguese': 'Portuguese',
}
// 登录页
const login = {
    'login.loginText': 'Sign in',
    'login.input.email': 'Email address(LenovoID)',
    'login.input.password': 'Password',
    'login.tip.noAccount': 'No account yet?',
    'login.tip.toRegister': 'Go to Sign up.',
    'login.tip.forget': 'Forget password?',
    'login.check.noInfo': 'Incorrect email or password.',
    'login.failed': 'Failed to sign in',
    'login.terms': 'Please check terms&conditions',
    'login.banner.flow': 'Register now and enjoy 1GB*6 months free data',
    'login.banner.VFflow': 'Register now and enjoy 5GB*3 months free data',
    'login.banner.coming': 'Promotion coming:',
    'login.banner.size': 'first month blows up to unlimited data'
}
// 注册页面
const register = {
    'register.registerText': 'Sign up',
    'register.input.firstName': 'First Name',
    'register.check.noFirstNameField': 'Please input First Name',
    'register.input.lastName': 'Last Name',
    'register.check.noLastNameField': 'Please input Last Name',
    'register.input.email': 'Email',
    'register.input.imgCode': 'Picture captcha',
    'register.input.verifyCode': 'Captcha',
    'register.input.password': 'Password',
    'register.input.rePassword': 'Confirm password',
    'register.input.alRegister': 'Already registered',
    'register.input.toLogin': 'Go to Sign in',
    'register.input.termsOfService': 'Terms of Use',
    'register.input.privacyStatement': 'Privacy Statement',
    'register.tip': 'By creating an account, you agree to the{termsOfService}and{privacyStatement}.',
    'register.tipForTablet': 'By creating the account, you have read and accepted the <a1>Preload Data Plan Descriptions</a1>, <a2>Terms and Conditions</a2> by Lenovo Connect, <a3>Terms and Conditions</a3> by HUE, <a4>Privacy Policy</a4> by Lenovo Connect, and <a5>Privacy Policy</a5> by HUE.',
    'register.sendMsg.text': 'Get captcha',
    'register.sendMsg.reSend': 'Resend',
    'register.sendMsg.sendSuccess': 'Sent successfully',
    'register.sendMsg.sendFailed': 'Failed to send',
    'register.check.noEmailField': 'Please input Email',
    'register.check.noImageCodeField': 'Please input picture captcha',
    'register.check.noVerifyField': 'Please input the captcha you got',
    'register.check.noPasswdField': 'Please input password',
    'register.check.noConfirmPasswd': 'Please confirm password',
    'register.check.errorEmail': 'The input is not valid E-mail',
    'register.check.errorVerifyCode': 'Incorrect captcha',
    'register.check.errorImageCode': 'Incorrect picture captcha',
    'register.check.errorPasswd': 'Incorrect password',
    'register.check.errorTwoPasswd': 'The two passwords that you entered do not match',
    'register.success': 'Sign up successfully',
}
// 首页
const home = {
    'home.header.upload': 'Upload',
    'home.header.iccid': 'ICCID Code',
    'home.flowUse.title': 'My Current Data Allowance',
    'home.flowUse.status.title': 'Usage Status',
    'home.flowUse.status.used': 'used this cycle',
    'home.flowUse.status.remaining': 'remaining',
    'home.flowUse.dataPlan.key': 'Data Plan Name',
    'home.flowUse.validity.key': 'Validity',
    'home.flowUse.note.key': 'Note',
    'home.flowUse.note': 'Once data allowance is reached in the current cycle, connectivity will halt till the next cycle.',
    'home.flowUse.leftDay': '{day} {unit} left',
    'home.flowUse.currentDataPlan.title': 'My Data Plan(s)',
    'home.flowUse.currentDataPlan.titleHue': 'My Connectivity Service Package',
    'home.flowUse.outDate': 'The data plan has expired',
    'home.flowUse.lock': 'sim card is locked',
    'home.flowUse.noDataPlan': 'No data plan used yet',
    'home.flowUse.status.unlimited': 'Unlimited',
    'home.area.intro.title': 'Top up Data Plans',
    'home.area.intro.titleHue': 'Top up',
    'home.area.intro.content': 'Our plans can cover all <cta>EU countries</cta> (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden),<cta> plus Iceland, Norway, Switzerland, United Kingdom and United States of America</cta>.',
    'home.area.intro.contentHUE': 'Our plans can cover all <cta>EU countries</cta> (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden),<cta> plus Iceland, Norway, Switzerland, United Kingdom.</cta>Please enable both Mobile Data&Roaming (no extra roaming fee).',
    'home.area.intro.vatIntro': 'Prices include VAT if applicable',
    'home.area.intro.suggest': 'Suggest',
    'home.area.switch.title': 'Region:',
    'home.active.title': 'Activate My Preload Data Plan',
    'home.active.intro': 'The "{packageContent}" preload data plan must be activated within 90 days of powering on device. Validity of {timeLength} immediately folllows the activation.',
    'home.active.agree': 'When you active it, you agree to the <a>Preload Data Plan Description</a>, <a1>Terms and Conditions</a1> and <a2>Privacy Policy.</a2> Lenovo Connect Powered by Truphone.',
    'home.active.agreeForTablet': 'When you active it, you agree to the <a>Preload Data Plan Description</a>, <a1>Terms and Conditions</a1> and <a2>Privacy Policy.</a2>',
    'home.active.btnText': 'Active Now',
    'home.active.failed': 'Activation failed !',
    'home.active.success': 'Activated successfully',
    'home.active.success.btn': 'OK',
    'home.active.detail.title': 'Preload Data Plan Description',
    'home.active.detail.faq': 'If you have any questions, please check <a>Customer Service</a>',
}
const me = {
    'me.signOut': 'Sign out',
    'me.nav.device': 'Device',
    'me.nav.package': 'Data Plan(s)',
    'me.nav.order': 'Order',
    'me.nav.accountInfo': 'Account Info',
    'me.nav.FAQ': 'FAQ',
    'me.nav.contactUs': 'Contact Us',
    'me.signOut.alert.title': 'Sign out',
    'me.signOut.alert.content': 'Are you sure to sign out?'
}
const suggest = {
    'suggest.title': 'Suggestion Box',
    'suggest.toast': 'Please enter content',
    'suggest.success': 'Successful',
    'suggest.suggestions': 'Please share your suggestions or questions with us',
    'suggest.submit': 'Submit',
    'suggest.information': 'Information',
    'suggest.submission': 'My Submission',
    'suggest.noMore': 'No more data',
    'suggest.uploadImg': 'Picture size shall not exceed 5M',
}
// 账号信息
const accountInfo = {
    'account.errorNickname': 'Nickname length must be 4-20 characters.',
    'account.account.fieldTitle': 'Account',
    'account.nickName.fieldTitle': 'Nickname',
    'account.nickName.character': '4-20 characters including letters, digits and "-"',
}
// 套餐卡片
const packageCard = {
    'package.validDate': 'valid {timeLength} {dateUnit}',
    'package.validTo': 'valid to {date} UTC',
    'package.orderBtnText': 'Order Now',
    'package.extend.title': 'Extend My Data Plan',
    'package.expand.title': 'Expand My Data Plan',
    'package.extend.titleHue': 'Subscribe to a monthly connectivity service package',
    'package.expand.titleHue': 'Add an extra connectivity service package',
    'package.expand.add': 'Add',
}
// 套餐详情
const packageDetail = {
    'packageDetail.privacy': 'Yes, I have read and accepted the <a>Terms and Conditions</a> and <b>Privacy Policy</b>. ',
    'packageDetail.privacyForTablet': 'Yes, I have read and accepted the <a>Terms and Conditions</a> and <b>Privacy Policy</b>. ',
    'packageDetail.description': 'Description',
    'packageDetail.expansionPackage.title': 'Expand the Current Cycle',
    'packageDetail.payBtn.text': 'Pay now',
}
// 地址
const billAddress = {
    'billAddress.history.title': 'Historical Billing Address',
    'billAddress.fieldWrap.title': 'Enter Your Billing Address',
    'billAddress.btn.continue': 'Continue',
    'billAddress.btn.cancel': 'Cancel',
    'billAddress.field.firstName': 'First Name',
    'billAddress.field.lastName': 'Last Name',
    'billAddress.field.email': 'Email',
    'billAddress.field.street': 'Street',
    'billAddress.field.city': 'City',
    'billAddress.field.state': 'State',
    'billAddress.tips.payment': 'How to pay?',
    'billAddress.tips.newCard': 'New Card',
    'billAddress.tips.oldCard': 'Old Card',
    'billAddress.field.postCode': 'Postcode',
    'billAddress.field.country': 'Country',
    'billAddress.field.firstNameError': 'First Name is a required field',
    'billAddress.field.lastNameError': 'Last Name is a required field',
    'billAddress.field.emailError': 'Email is a required field',
    'billAddress.field.emailFormatError': 'Enter a valid email',
    'billAddress.field.streetError': 'Street is a required field',
    'billAddress.field.cityError': 'City is a required field',
    'billAddress.field.stateError': 'State is a required field',
    'billAddress.field.postCodeError': 'Post Code is a required field',
    'billAddress.field.countryError': 'Country is a required field',
}
// 订单
const order = {
    'order.subType.1': 'preload',
    'order.subType.2': 'top-up',
    'order.subType.4': 'exchange',
    'order.subType.5': 'gift',
    'order.subType.6': '企业订购',
    'order.subType.7': '体验包',
    'order.subType.8': 'upgrade',
    'order.subType.9': 'refueling',
    'order.subType.systemOrder': 'System order',
    'order.item.orderNum': 'Order Number',
    'order.item.content': 'Content',
    'order.item.orderType': 'Order Type',
    'order.item.validity': 'Validity',
    'order.item.subTotal': 'Subtotal',
    'order.item.vat': 'VAT',
    'order.item.totalFee': 'Total',
    'order.noInfo.message': 'You haven\'t ordered any plans yet.！',
    'order.noInfo.btnText': 'Go to home'
}

// 支付结果页
const payResult = {
    'pay.success': 'Payment successful',
    'pay.fail': 'Payment failed',
    'pay.checkOrder': 'Check order',
    'pay.back': 'Back',
    'pay.continue': 'Continue to order',
}

// 我的设备页面
const device = {
    'device.switch': 'Switch Device',
    'device.status.current': 'Current',
    'device.status.available': 'Available',
    'device.switch.alert.title': 'Prompt',
    'device.switch.alert.content': 'Confirm to switch to this device?',
    'device.noInfo.message': 'You haven\'t bound any devices yet.',
    'device.noInfo.btnText': 'Upload ICCID Code',
    'device.edit.prompt.message': 'please input your nickName',
    'device.edit.check.none': 'Nickname is a required field'
}

// 我的套餐
const myDataPlan = {
    'myDataPlan.tabbar.available': 'Available Data Plan(s)',
    'myDataPlan.tabbar.expired': 'Expired Data Plan(s)',
    'myDataPlan.noAvailablePlan': 'No available plan(s) now',
    'myDataPlan.noExpiredPlan': 'No expired plan(s) now',
}
// 联系我们
const Contact = {
    'contact.chooseRegion.text': 'Choose your region',
    'contact.country.AT': 'Austria',
    'contact.country.BE': 'Belgium',
    'contact.country.DK': 'Denmark',
    'contact.country.FI': 'Finland',
    'contact.country.FR': 'France',
    'contact.country.DE': 'Germany',
    'contact.country.IE': 'Ireland',
    'contact.country.IT': 'Italy',
    'contact.country.LUX': 'Luxembourg',
    'contact.country.NL': 'Netherlands',
    'contact.country.NO': 'Norway',
    'contact.country.PT': 'Portugal',
    'contact.country.ES': 'Spain',
    'contact.country.SE': 'Sweden',
    'contact.country.CH': 'Switzerland',
    'contact.country.UK': 'United Kingdom',
    'contact.country.USA': 'USA',
    'contact.country.EN': 'USA',

    'contact.contactus.EN': 'Please contact service@lenovoconnect.com for order details and customer service.',

    'contact.phone.AT': '(+43) (0)1 9287 666',
    'contact.phone.BE': '02-700-73-77 (lokaal tarief)',
    'contact.phone.DK': '+45 89881536',
    'contact.phone.FI': '+358 97 47 90 251',
    'contact.phone.FR': '+ 33 170 381 927',
    'contact.phone.DE': '(+49) (0)201 22099 888',
    'contact.phone.IE': '1-890-928-860 (Calls to this number are charged at local rate from a landline and have a minimum cost of €0.05. Calls from mobiles may vary.)',
    'contact.phone.IT': '(+39)02 303 10000',
    'contact.phone.LUX': '+352 2487 16 11',
    'contact.phone.NL': '+31 204 990 153',
    'contact.phone.NO': '+47 67 204501',
    'contact.phone.PT': '+351 211 227 833',
    'contact.phone.ES': '+34 9179 11 799',
    'contact.phone.SE': '+46 840 30 01 81',
    'contact.phone.CH': '+41 44 798 2222',
    'contact.phone.UK': '+44 333-777-3991 (National Rate)',
    'contact.phone.USA': '1-800-426-7378, #1',

    'contact.workHours.AT': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.BE': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.DK': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.FI': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.FR': '09:00 - 18:00 Lundi - Vendredi',
    'contact.workHours.DE': '8 - 18 Uhr Montag - Freitag',
    'contact.workHours.IE': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.IT': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.LUX': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.NL': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.NO': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.PT': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.ES': 'de 8:00h a 18:00h, de lunes a viernes',
    'contact.workHours.SE': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.CH': '9:00 - 18:00 Monday - Friday',
    'contact.workHours.UK': '09:00 - 18:00 Monday - Friday',
    'contact.workHours.USA': '00:00 - 24:00 Monday - Sunday',
}
// 绑卡页面
const bindSim = {
    'bindSim.hello': 'Hello',
    'bindSim.activate.title': 'Activate Your Data Plan',
    'bindSim.tip.text1': 'Upload barcode image to bind card.',
    'bindSim.tip.text2': 'Activate the data plan and enjoy it!',
    'bindSim.btn.text': 'Upload image',
}
// FAQ页面
const FAQ = {
    'faq.question.1': 'Can I make calls or send SMS?',
    'faq.question.2': 'How can I buy a data plan and check my order record?',
    'faq.question.3': 'What are the rules of ordering data?',
    'faq.question.4': 'What payment methods can I use?',
    'faq.question.5': 'How do I turn off my data plan if I don\'t want to use it?',
    'faq.question.6': 'I have successfully ordered a data plan, why can\'t I use it?',
    'faq.question.7': 'What if I cannot get Internet access?',
    'faq.question.8': 'What countries can the data plan cover?',
    'faq.question.9': 'How do I reach Lenovo Customer Service?',
    'faq.question.10': 'How do I request a receipt for my order?',
    'faq.question.11': 'How to replace a SIM card?',
    'faq.question.12': 'Is it free to replace a SIM?',
    'faq.question.13': 'Can I suspend the activated data plan if my SIM is lost, broken or faulty?',
    'faq.question.14': 'What if I forgot my password?',
    'faq.question.15': 'Can I make changes after my SIM card\'s ICCID and my Lenovo ID are bound?',
    'faq.question.16': 'What should I do if the device asks me to enter a PIN, PIN 2 or PUK code, or to enter an APN?',
    'faq.question.17': 'How do I check my SIM\'s ICCID?',
    'faq.question.18': 'CONTACT US',
    'faq.answer.1': 'The SIM only supports data for network access. You will not receive a mobile number. You can still make calls or send SMS using Apps like Skype, Whatsapp.',
    'faq.answer.2': 'Please visit aoacwap.lenovoconnect.com to proceed.',
    'faq.answer.3': 'Connectivity Service Package ordered successfully will be automatically activated (e.g. Expand My Data Plan) or will wait in queue to be activated (e.g. Extend My Data Plan). We do not support data plan refund or suspension. ',
    'faq.answer.4': 'We sell plans in GBP, EUR, USD,CHF, NOK, DKK, SEK and support Credit/Debit Visa or Master cards.',
    'faq.answer.5': 'If you want to stop using cellular connectivity, please click OFF the "Mobile data"      . Please be noted that your ongoing data plan will NOT be suspended or refunded. ',
    'faq.answer.6.1': '1) If the ordered plan is to extend your current plan, it can only be activated once your current plan expires. ',
    'faq.answer.6.2': '2) If the ordered plan is to expand your current plan, it should be activated automatically. Please refer to other FAQ for connectivity issue, or contact Lenovo.com Customer Service in your own country.',
    'faq.answer.6.3': '3) If you have multiple devices under the same Lenovo ID, please ensure the ordered data plan is under the ICCID of the current used device\'s SIM. ',
    'faq.answer.7.1': '1) Check if "Mobile data" is switched ON.',
    'faq.answer.7.2': '2) Check if "Data roaming" is enabled. Go to Settings->Network&Internet->Mobile network->Data roaming',
    'faq.answer.7.3': '3) Check if Access Point Name (APN) is correctly set up.Go to Settings->Network&Internet->Mobile network->Advanced->Access point names-> add APN: net.truphone.com',
    'faq.answer.7.4': '4) If this is your first connection, it might take a few minutes for the SIM to connect. ',
    'faq.answer.7.5': '5) Please ensure the preload data plan is activated; if not, please follow the instructions in the SIM package to activate. ',
    'faq.answer.7.6': '6) Make sure your current location is within our service coverage scope (See full list of covered countries below) Move your device beside a window or an open area in order to receive a better signal. ',
    'faq.answer.8': 'The data plan can cover all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, United Kingdom and United States of America.',
    'faq.answer.8.1': 'The data plan can cover all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Gibraltar, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, United Kingdom.',
    'faq.answer.9': 'Please refer to below Customer Service information of Lenovo.com in your own country.',
    'faq.answer.10': 'The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it.  If still not received, please contact Lenovo Customer Service.',
    'faq.answer.11': 'If your SIM is broken, lost or faulty, please contact Lenovo Customer Service for a solution.',
    'faq.answer.12': 'Yes, but courier service charge may apply. Please contact Lenovo Customer Service for details.',
    'faq.answer.13': 'Sorry, the data plan cannot be suspended.',
    'faq.answer.14': 'You can re-set your password via " Forgot password " on the Sign in page',
    'faq.answer.15': 'Yes. Please contact Lenovo Customer Service for such request. After verification, Customer Service staff will help remove the current binding between the SIM\'s ICCID and your Lenovo ID. Note that connectivity service package within validities cannot be suspended or unsubscribed regardless of the SIM-Lenovo ID binding status.',
    'faq.answer.16': 'Try deactivating and reactivating Cellular and also restarting the device. If this does not help, please contact our Customer Service.',
    'faq.answer.17.1': '1) You can find the ICCID on the SIM chip or the SIM holder.',
    'faq.answer.17.2': '2) If you have activated the SIM and preload data plan, please visit aoacwap.lenovoconnect.com and check "Me"->"Device"',
    'faq.answer.18': 'Please refer to Customer Service information on Lenovo website in your country.',
}
//平板faq
const faqApp = {
    'faq.title.1': 'FAQ-About Lenovo Connect',
    'faq.question.1': 'Q1: How do I reach Lenovo Customer Service if the following answers cannot solve my question? ',
    'faq.answer.1': 'A1: Please refer to below Customer Service information on Lenovo.com in your own country. Or directly send an email to: service@lenovoconnect.com. Please include the ICCID of the SIM in the email.',
    'faq.question.2': 'Q2: Can I make calls or send SMS?',
    'faq.answer.2': 'A2: The SIM only supports data for network. You will not receive a mobile number. It does not support voice or SMS.',
    'faq.question.3': 'Q3: Can the SIM be switched to other devices?',
    'faq.answer.3': 'A3: The SIM only can be used in the tablet. Cannot be switched to other devices.',
    'faq.question.4': 'Q4: What countries can the data plan cover? Will there be extra roaming fee?',
    'faq.answer.4': 'A4: The data plan covers all EU countries (Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden), plus Iceland, Norway, Switzerland, and United Kingdom. There is no extra roaming fee within these places.',
    'faq.title.2': 'FAQ-About Connectivity Service Package',
    'faq.question.5': 'Q1: How can I buy a service package and check my order record? Can the unused data roll into the next 30 days?',
    'faq.answer.5': 'A1: Please visit the app "Len" preloaded on the tablet. Or visit aoacwap.lenovoconnect.com to check the data usage. If the current package is not used up, it cannot be rolled into the next 30 days.',
    'faq.question.6': 'Q2: When does the gift package start to count?',
    'faq.answer.6': 'A2: The gift package starts after the register and log in to the APP "Len", and activate the preload package on the homepage.',
    'faq.question.7': 'Q3: What are the rules of ordering connectivity service package?',
    'faq.answer.7': 'A3: Service package ordered successfully will be automatically activated (e.g. Subscribe To A Monthly Connectivity Service Package) or will wait in queue to be activated after the current service was exhausted (e.g. Add An Extra Connectivity Service Package). Service package does not support refund or suspension.',
    'faq.question.8': 'Q4: What payment methods can I use?',
    'faq.answer.8': 'A4: We support Credit/Debit Visa or Master cards in GBP, EUR, USD,CHF, NOK, DKK, SEK.',
    'faq.question.9': "Q5: I have successfully ordered the service package, why can't I use it?",
    'faq.answer.9': 'A5: If it is to add an extra connectivity service package, it can only be activated once your current package expires. If it is to subscribe to a monthly connectivity service package, it should be activated automatically. Please refer to other FAQs for connectivity issue, or contact Lenovo Customer Service or email: service@lenovoconnect.com.',
    'faq.title.3': 'FAQ-About APP Len',
    'faq.question.10': 'Q1: What if I cannot find the APP or the APP was deleted by mistake?',
    'faq.answer.10': `A1: Please visit Tablet Center to re-download the APP. Or visit the link to re-download: https://aoacupg.lenovoconnect.com/common/downloadLatest`,
    'faq.question.11': "Q2: What should I do if I can't log in to the APP?",
    'faq.answer.11.1': 'A2: 1. It may take a longer time to log in to the APP for the first time. Please wait for about half a minute.',
    'faq.answer.11.2': '2. Please try to exit the APP completely and then re-enter.',
    'faq.answer.11.3': '3. If the APP registration page shows: This email has existed. Please log in directly with your previous Lenovo ID or register with a new email address.',
    'faq.answer.11.4': '4. If the APP login page shows: Card has bound by other accounts. In this case, you have already bound this card to an email account. To unbind and reset your email, please contact the customer service team or email service@lenovoconnect.com',
    'faq.question.12': 'Q3: What if I forgot my password of the registered email?',
    'faq.answer.12': 'A3: You can re-set your password via "Forgot password" on the Sign in page of the APP.',
    'faq.title.4': 'FAQ-About using data',
    'faq.question.13': "Q1: How should I turn off my connectivity package if I don't want to use it?",
    'faq.answer.13': 'A1：If you want to stop using cellular connectivity, please click OFF the "Mobile data". Please note that your ongoing package will NOT be suspended or refunded.',
    'faq.question.14': 'Q2：What if I cannot get Internet access?',
    'faq.answer.14.1': 'A2：1. Please check that "Settings--Network&Internet--Mobile data”is turned on.',
    'faq.answer.14.2': '2. Please check that "Settings--Network&Internet--Data roaming”is turned on (need to be turned on, there will be no additional roaming charges).ƒ',
    'faq.answer.14.3': '3. Check the "Settings-Network&Internet-Advanced-Access Point Names" are set correctly, it should be set to: lenovo.m2m.drei.at (Please add manually if there is not)',
    'faq.answer.14.4': '4. If this is your first time to connect, it may take a few minutes.',
    'faq.answer.14.5': '5. Please log in to the APP Len and confirm that the free data package has been activated. If it is not activated, please log in to the APP and click "Activation" on the main page.',
    'faq.answer.14.6': '6. Please confirm that your region is within the scope of service (please refer to the following countries for details). You can move to a more open place to receive the signal. (Covering all EU countries Austria, Belgium, Bulgaria, Croatia, Cyprus, Czech Republic, Denmark, Estonia, Finland, France, Germany, Greece, Hungary, Ireland, Italy, Latvia, Lithuania, Luxembourg, Malta, Netherlands, Poland, Portugal, Romania, Slovak Republic, Slovenia, Spain, Sweden, plus Iceland, Norway, Switzerland, and United Kingdom).',
    'faq.answer.14.7': '7. Please check whether the SIM card is installed correctly and restart the device.',
    'faq.answer.14.8': '8. Please check Settings-Network&Internet-Choose network, you can manually select the network among them. If "forbidden" is displayed after a network is found, please click and clear "forbidden" manually. If there is no forbidden displayed, you may change the SIM into your phone, acting the same process to see available networks.',
    'faq.question.15': "Q3: How do I check my SIM's ICCID?",
    'faq.answer.15.1': 'A3:  1. Please pull out the SIM card inserted in the tablet, the ICCID is on the card.',
    'faq.answer.15.2': '2. Please visit App Len-Me-Device',
    'faq.answer.15.3': '3. Please visit aoacwap.lenovoconnect.com and you will see your ICCID on the page.',
    'faq.question.16': 'Q4: How do I request a receipt for my order?',
    'faq.answer.16.1': 'A4: The receipt will be sent to your registered email address automatically after ordering successfully. Please do check both your inbox and junk mail box for it. If still cannot find it, please contact Lenovo Customer Service or email: service@lenovoconnect.com',
    'faq.title.5': 'FAQ-About SIM Card',
    'faq.question.17': "Q1: Can I make changes after my SIM card's ICCID and my Lenovo ID are bound?",
    'faq.answer.17': 'A1: Yes. Please contact Lenovo Customer Service or email: service@lenovoconnect.com for the unbinding request. Please note that connectivity service package within validity cannot be suspended or refunded regardless of the SIM-Lenovo ID binding status.',
    'faq.question.18': 'Q2: What should I do if the card surface is damaged or lost? Can an activated service package be suspended?',
    'faq.answer.18': 'A2: If your SIM is broken or lost or faulty, please contact Lenovo Customer Service or email: service@lenovoconnect.com. We will arrange a new delivery after the confirmation of the detailed situation. The activated package cannot be suspended or refunded.',
}
// 接口返回错误码
const iCode = {
    'iCode.i0001': 'password error',
    'iCode.i0002': 'This email has existed',
    'iCode.i0003': 'Password format error',
    'iCode.i0004': 'Account must be activated before login.',
    'iCode.i0005': 'Account is disabled',
    'iCode.i0006': 'Login timeout',
    'iCode.i0007': 'error',
    'iCode.i0008': 'Error account or password',
    'iCode.i0009': 'Please enter 5-digit graphic verification code',
    'iCode.i0010': 'Operation is too frequent. Please try again later.',
    'iCode.i0011': 'Invalid callback address.',
    'iCode.i0012': 'Invalid signature.',
    'iCode.i0013': 'Please refresh verification code',
    'iCode.i0014': 'Server error.',
    'iCode.i0015': 'Service Good ID is empty',
    'iCode.i0016': 'Message sent successfully',
    'iCode.i0017': 'Message sending failed',
    'iCode.i0018': '兑换码错误',
    'iCode.i0019': '请在兑换期内使用',
    'iCode.i0020': '兑换码已过期',
    'iCode.i0021': '兑换码已使用',
    'iCode.i0022': '兑换码已失效',
    'iCode.i0023': 'Order is being created, please wait…',
    'iCode.i0024': 'Operatoin failed',
    'iCode.i0025': '号卡不满足兑换条件',
    'iCode.i0026': 'QR code generation failed',
    'iCode.i0027': '创建升级订单信息有误',
    'iCode.i0028': 'SIM doesn\'t exist',
    'iCode.i0029': '手机号格式错误',
    'iCode.i0030': '短信发送太频繁',
    'iCode.i0031': 'Parameter error',
    'iCode.i0032': 'The number of sending verification code within a day has reached the upper limit',
    'iCode.i0033': '注册成功',
    'iCode.i0034': 'Account registration failed',
    'iCode.i0035': 'Please bind SIM ICCID first',
    'iCode.i0036': 'Please log in account first',
    'iCode.i0037': 'Status update failed',
    'iCode.i0038': '启用中， 请稍后',
    'iCode.i0039': 'Order ID is empty',
    'iCode.i0040': 'Activation in progress, please wait',
    'iCode.i0041': 'Package is off the shelf',
    'iCode.i0042': 'Activation failed!',
    'iCode.i0043': 'Activation succeeded!',
    'iCode.i0044': 'System cannot identify the SIM',
    'iCode.i0045': 'Package activated, do not repeat',
    'iCode.i0046': 'No activated packages',
    'iCode.i0047': 'SIM discontinued',
    'iCode.i0048': 'Incorrect package information',
    'iCode.i0049': 'User or password is empty',
    'iCode.i0050': 'No basic package for the month',
    'iCode.i0051': 'Login successfully',
    'iCode.i0052': 'Abnormal login',
    'iCode.i0053': 'Device is empty',
    'iCode.i0054': 'Verification code error, please re-enter',
    'iCode.i0055': 'Successful operation',
    'iCode.i0056': 'SIM is empty',
    'iCode.i0057': 'Failed to get token',
    'iCode.i0058': '企业编码不存在',
    'iCode.i0059': 'Use of SIM is inconsistent with enterprise\'s properties',
    'iCode.i0060': 'Please don\'t operate frequently',
    'iCode.i0061': '领取优惠券成功',
    'iCode.i0062': '不满足领取条件',
    'iCode.i0063': '领取优惠券出错',
    'iCode.i0064': 'Iccid binding failed',
    'iCode.i0065': 'Card has binded by other account',
    'iCode.i0066': 'Binding succeeded',
    'iCode.i0067': 'Binding error',
    'iCode.i0068': 'SIM ID is empty',
    'iCode.i0069': 'esimId为空',
    'iCode.i0070': 'No SIM binding',
    'iCode.i0071': 'User doesn\'t exist',
    'iCode.i0072': 'Nickname cannot be empty',
    'iCode.i0073': 'Successfully updated',
    'iCode.i0074': 'Failed updated',
    'iCode.i0075': 'Homepage no SIM abnormal package query',
    'iCode.i0076': 'Relevant information not available',
    'iCode.i0077': 'Failed to generate encrypted signature.',
    'iCode.i0078': 'Switch failed',
    'iCode.i0079': 'Switch succeeded',
    'iCode.i0080': 'Please don\'t submit applications repeatedly!',
    'iCode.i0081': 'Please refresh and trial again!',
    'iCode.i0082': 'Failed to get banner graph of homepage',
    'iCode.i0083': 'Currently no bound ICCID, no preferential package',
    'iCode.i0084': 'Currently no bound ICCID, no availabel package',
    'iCode.i0085': '认证成功',
    'iCode.i0086': '认证失败',
    'iCode.i0087': 'System exception',
    'iCode.i0088': '卡已实名',
    'iCode.i0089': 'Plan is ordered successfully',
    'iCode.i0090': 'Plan order failed',
    'iCode.i0091': '服务商品不存在',
    'iCode.i0092': '升级服务订单生成完毕',
    'iCode.i0093': '无升级套餐服务',
    'iCode.i0094': 'No corresponding order found',
    'iCode.i0095': 'Current package is not paid',
    'iCode.i0096': 'Package ID is empty in the order',
    'iCode.i0097': '套餐已启用',
    'iCode.i0098': 'Successful order',
    'iCode.i0099': '暂无码号可用',
    'iCode.i0100': '无该地区码号',
    'iCode.i0104': 'Unable to get sub-region of sim card',
    'iCode.i0109': 'Failed to read barcode, please try again',
    'iCode.i0124': 'Payment failed',
}
export default {
    ...common,
    ...language,
    ...login,
    ...register,
    ...home,
    ...me,
    ...packageCard,
    ...packageDetail,
    ...billAddress,
    ...order,
    ...device,
    ...accountInfo,
    ...myDataPlan,
    ...FAQ,
    ...iCode,
    ...payResult,
    ...Contact,
    ...bindSim,
    ...suggest,
    ...faqApp,
    'tab.text.home': 'Home',
    'tab.text.me': 'Me'
}
